import {createIconComponent} from './createIconComponent';
import UserIcon from '../../assets/images/icons/user-light-full.svg?react';
import ProductionIcon from '../../assets/images/icons/print-light-full.svg?react';
import LeadFormIcon from '../../assets/images/icons/rectangle-list-light-full.svg?react';
import ProfileIcon from '../../assets/images/icons/profile-user-vneck-hair-light-full.svg?react';
import LeadIcon from '../../assets/images/icons/leads-address-book-light-full.svg?react';
import EnvelopeIcon from '../../assets/images/icons/envelope-light-full.svg?react';
import OrderIcon from '../../assets/images/icons/orders-receipt-light-full.svg?react';
import TableIcon from '../../assets/images/icons/table-light-full.svg?react';
import UsersIcon from '../../assets/images/icons/users-light-full.svg?react';
import OrganizationIcon from '../../assets/images/icons/building-magnifying-glass-light-full.svg?react';
import SubscriptionsIcon from '../../assets/images/icons/euro-sign-light-full.svg?react';
import AccountTriggerIcon from '../../assets/images/icons/circle-user-light-full.svg?react';
import AccountIcon from '../../assets/images/icons/account-profile-user-vneck-hair-light-full.svg?react';
import InviteMemberIcon from '../../assets/images/icons/user-plus-light-full.svg?react';
import OrgSettingsIcon from '../../assets/images/icons/building-memo-light-full.svg?react';
import BuyIcon from '../../assets/images/icons/cart-shopping-light-full.svg?react';
import LogoutIcon from '../../assets/images/icons/right-from-bracket-light-full.svg?react';
import KompanyIcon from '../../assets/images/icons/building-light-full.svg?react';
import MediumIcon from '../../assets/images/icons/nfc-signal-light-full.svg?react';
import MediumProdIcon from '../../assets/images/icons/supports-nfc-pen-light-full.svg?react';
import StatsIcon from '../../assets/images/icons/chart-simple-light-full.svg?react';
import GlobalStatsIcon from '../../assets/images/icons/chart-mixed-light-full.svg?react';
import AssetIcon from '../../assets/images/icons/folder-open-light-full.svg?react';
import SettingsIcon from '../../assets/images/icons/gear-light-full.svg?react';
import HelpIcon from '../../assets/images/icons/comment-question-light-full.svg?react';
import ChevronLeftIcon from '../../assets/images/icons/chevron-left-light-full.svg?react';
import StatViewsIcon from '../../assets/images/icons/eyes-light-full.svg?react';
import StatProfileScanIcon from '../../assets/images/icons/user-viewfinder-light-full.svg?react';
import ReportIcon from '../../assets/images/icons/file-chart-column-light-full.svg?react';
import DropzoneIcon from '../../assets/images/icons/cloud-arrow-up-light-full.svg?react';
import EditIcon from '../../assets/images/icons/pen-light-full.svg?react';
import ViewIcon from '../../assets/images/icons/eye-light-full.svg?react';
import AddIcon from '../../assets/images/icons/plus-light-full.svg?react';
import PlusIcon from '../../assets/images/icons/plus-light-full.svg?react';
import MinusIcon from '../../assets/images/icons/minus-light-full.svg?react';
import CampaignIcon from '../../assets/images/icons/bullhorn-light-full.svg?react';
import ModelIcon from '../../assets/images/icons/paintbrush-pencil-light-full.svg?react';
import DeleteIcon from '../../assets/images/icons/trash-light-full.svg?react';
import EditProfileIcon from '../../assets/images/icons/pen-to-square-light-full.svg?react';
import ShareIcon from '../../assets/images/icons/share-nodes-light-full.svg?react';
import ProfileSettingsIcon from '../../assets/images/icons/settings-sliders-light-full.svg?react';
import PermissionsIcon from '../../assets/images/icons/rights-shield-user-light-full.svg?react';
import TagsIcon from '../../assets/images/icons/tags-light-full.svg?react';
import TagSingleIcon from '../../assets/images/icons/tag-light-full.svg?react';
import DownloadIcon from '../../assets/images/icons/down-to-line-light-full.svg?react';
import ManualEntryIcon from '../../assets/images/icons/pen-field-light-full.svg?react';
import CameraScanIcon from '../../assets/images/icons/camera-viewfinder-dashboard-light-full.svg?react';
import FeaturesIcon from '../../assets/images/icons/toggle-on-light-full.svg?react';
import PlanIcon from '../../assets/images/icons/receipt-light-full.svg?react';
import MembersIcon from '../../assets/images/icons/people-group-light-full.svg?react';
import TeamsIcon from '../../assets/images/icons/screen-users-light-full.svg?react';
import SecurityIcon from '../../assets/images/icons/shield-check-light-full.svg?react';
import IntegrationsIcon from '../../assets/images/icons/plug-light-full.svg?react';
import SsoIcon from '../../assets/images/icons/key-light-full.svg?react';
import VcardIcon from '../../assets/images/icons/address-card-light-full.svg?react';
import LeadCaptureIcon from '../../assets/images/icons/address-card-paper-light-full.svg?react';
import ExchangeIcon from '../../assets/images/icons/rotate-light-full.svg?react';
import ShareProfileIcon from '../../assets/images/icons/share-light-full.svg?react';
import MenuBarsIcon from '../../assets/images/icons/bars-light-full.svg?react';
import CloseIcon from '../../assets/images/icons/xmark-light-full.svg?react';
import NoneIcon from '../../assets/images/icons/empty-set-light-full.svg?react';
import PhoneIcon from '../../assets/images/icons/phone-light-full.svg?react';
import VideoIcon from '../../assets/images/icons/video-light-full.svg?react';
import FileIcon from '../../assets/images/icons/file-light-full.svg?react';
import CalendarIcon from '../../assets/images/icons/calendar-light-full.svg?react';
import LinkExternalIcon from '../../assets/images/icons/link-external-light-full.svg?react';
import OpenExternalIcon from '../../assets/images/icons/up-right-from-square-light-full.svg?react';
import CopyIcon from '../../assets/images/icons/clone-light-full.svg?react';
import LockedIcon from '../../assets/images/icons/lock-keyhole-light-full.svg?react';
import NotAllowedIcon from '../../assets/images/icons/ban-light-full.svg?react';
import MergeIcon from '../../assets/images/icons/merge-light-full.svg?react';
import ImpersonateIcon from '../../assets/images/icons/ghost-light-full.svg?react';
import ToggleOnLargeIcon from '../../assets/images/icons/toggle-large-on-regular-full.svg?react';
import ToggleOffLargeIcon from '../../assets/images/icons/toggle-large-off-regular-full.svg?react';
import OrderTransitionIcon from '../../assets/images/icons/arrows-turn-to-dots-light-full.svg?react';
import MoveToOrgIcon from '../../assets/images/icons/building-circle-arrow-right-light-full.svg?react';
import WooCommerceIcon from '../../assets/images/icons/wordpress-simple-brands-solid-full.svg?react';
import SaveIcon from '../../assets/images/icons/floppy-disk-light-full.svg?react';
import ImageIcon from '../../assets/images/icons/image-light-full.svg?react';
import ViewOffIcon from '../../assets/images/icons/eye-slash-light-full.svg?react';
import AllOrganizationsIcon from '../../assets/images/icons/buildings-light-full.svg?react';
import FingerprintIcon from '../../assets/images/icons/fingerprint-sharp-duotone-light-full.svg?react';
import ViewListIcon from '../../assets/images/icons/list-light-full.svg?react';
import ViewGridIcon from '../../assets/images/icons/grid-2-light-full.svg?react';
import CheckIcon from '../../assets/images/icons/check-light-full.svg?react';
import DeleteForeverIcon from '../../assets/images/icons/trash-can-light-full.svg?react';
import RefreshIcon from '../../assets/images/icons/rotate-right-light-full.svg?react';
import BackIcon from '../../assets/images/icons/arrow-left-light-full.svg?react';
import SendIcon from '../../assets/images/icons/paper-plane-top-light-full.svg?react';
import ChevronDownIcon from '../../assets/images/icons/chevron-down-light-full.svg?react';
import NextIcon from '../../assets/images/icons/arrow-right-light-full.svg?react';
import LockIcon from '../../assets/images/icons/user-key-light-full.svg?react';
import QrCodeIcon from '../../assets/images/icons/qrcode-light-full.svg?react';
import ErrorIcon from '../../assets/images/icons/triangle-exclamation-light-full.svg?react';
import InfoIcon from '../../assets/images/icons/circle-info-light-full.svg?react';
import CheckCircleIcon from '../../assets/images/icons/circle-check-light-full.svg?react';
import WarningIcon from '../../assets/images/icons/circle-exclamation-light-full.svg?react';
import QuestionIcon from '../../assets/images/icons/circle-question-light-full.svg?react';
import AlertIcon from '../../assets/images/icons/bell-light-full.svg?react';
import SortIcon from '../../assets/images/icons/arrow-up-arrow-down-light-full.svg?react';
import FilterIcon from '../../assets/images/icons/filter-list-light-full.svg?react';
import ClearFiltersIcon from '../../assets/images/icons/filter-circle-xmark-light-full.svg?react';
import TranslateIcon from '../../assets/images/icons/language-light-full.svg?react';
import PublicIcon from '../../assets/images/icons/globe-light-full.svg?react';
import AttachmentIcon from '../../assets/images/icons/paperclip-light-full.svg?react';
import EmailIcon from '../../assets/images/icons/at-light-full.svg?react';
import CustomizeIcon from '../../assets/images/icons/palette-light-full.svg?react';
import DragHandleIcon from '../../assets/images/icons/grip-dots-vertical-light-full.svg?react';
import UploadIcon from '../../assets/images/icons/arrow-up-from-bracket-light-full.svg?react';
import CheckboxEmptyIcon from '../../assets/images/icons/square-light-full.svg?react';
import AdminShieldIcon from '../../assets/images/icons/user-shield-light-full.svg?react';
import TransferIcon from '../../assets/images/icons/arrow-right-arrow-left-light-full.svg?react';
import MoreVertIcon from '../../assets/images/icons/ellipsis-vertical-light-full.svg?react';
import MoreHorizIcon from '../../assets/images/icons/ellipsis-light-full.svg?react';
import GearsIcon from '../../assets/images/icons/gears-light-full.svg?react';
import LinkOffIcon from '../../assets/images/icons/link-slash-light-full.svg?react';
import NfcIcon from '../../assets/images/icons/microchip-light-full.svg?react';
import LocationIcon from '../../assets/images/icons/location-dot-light-full.svg?react';
import CreditCardIcon from '../../assets/images/icons/credit-card-light-full.svg?react';
import ContactCardIcon from '../../assets/images/icons/address-book-light-full.svg?react';
import FlagIcon from '../../assets/images/icons/flag-light-full.svg?react';
import SearchIcon from '../../assets/images/icons/magnifying-glass-light-full.svg?react';
import HomeIcon from '../../assets/images/icons/house-light-full.svg?react';
import RecycleIcon from '../../assets/images/icons/recycle-light-full.svg?react';
import ArticleIcon from '../../assets/images/icons/newspaper-light-full.svg?react';
import AirplaneOfflineIcon from '../../assets/images/icons/plane-light-full.svg?react';
import MagicIcon from '../../assets/images/icons/wand-magic-sparkles-light-full.svg?react';
import TrackingIcon from '../../assets/images/icons/bullseye-pointer-light-full.svg?react';
import FilePdfIcon from '../../assets/images/icons/file-pdf-light-full.svg?react';
import FileAudioIcon from '../../assets/images/icons/file-audio-light-full.svg?react';
import FileVideoIcon from '../../assets/images/icons/file-video-light-full.svg?react';
import PasteIcon from '../../assets/images/icons/clipboard-light-full.svg?react';
import AddToHomeScreenIcon from '../../assets/images/icons/mobile-screen-button-light-full.svg?react';
import LockOpenIcon from '../../assets/images/icons/lock-open-light-full.svg?react';
import GiftIcon from '../../assets/images/icons/gift-light-full.svg?react';
import MobileIcon from '../../assets/images/icons/mobile-light-full.svg?react';
import ShieldCheckIcon from '../../assets/images/icons/shield-check-sharp-light-full.svg?react';
import CrownIcon from '../../assets/images/icons/crown-light-full.svg?react';

// WYSIWYG editor toolbar — dedicated keys (no mutualization with the rest of the app)
import WysiwygBoldIcon from '../../assets/images/icons/bold-light-full.svg?react';
import WysiwygItalicIcon from '../../assets/images/icons/italic-light-full.svg?react';
import WysiwygUnderlineIcon from '../../assets/images/icons/underline-light-full.svg?react';
import WysiwygStrikethroughIcon from '../../assets/images/icons/strikethrough-light-full.svg?react';
import WysiwygClearFormatIcon from '../../assets/images/icons/eraser-light-full.svg?react';
import WysiwygTextColorIcon from '../../assets/images/icons/font-light-full.svg?react';
import WysiwygTextHighlightIcon from '../../assets/images/icons/highlighter-light-full.svg?react';
import WysiwygTextIncreaseIcon from '../../assets/images/icons/plus-light-full.svg?react';
import WysiwygTextDecreaseIcon from '../../assets/images/icons/minus-light-full.svg?react';
import WysiwygAlignLeftIcon from '../../assets/images/icons/align-left-light-full.svg?react';
import WysiwygAlignCenterIcon from '../../assets/images/icons/align-center-light-full.svg?react';
import WysiwygAlignRightIcon from '../../assets/images/icons/align-right-light-full.svg?react';
import WysiwygAlignJustifyIcon from '../../assets/images/icons/align-justify-light-full.svg?react';
import WysiwygListBulletedIcon from '../../assets/images/icons/list-ul-light-full.svg?react';
import WysiwygListNumberedIcon from '../../assets/images/icons/list-ol-light-full.svg?react';
import WysiwygQuoteIcon from '../../assets/images/icons/quote-left-light-full.svg?react';
import WysiwygLinkIcon from '../../assets/images/icons/link-light-full.svg?react';
import WysiwygUndoIcon from '../../assets/images/icons/arrow-rotate-left-light-full.svg?react';
import WysiwygRedoIcon from '../../assets/images/icons/arrow-rotate-right-light-full.svg?react';
// WYSIWYG — keys reusing existing SVGs (different context, dedicated key for future divergence)
import WysiwygSaveIcon from '../../assets/images/icons/floppy-disk-light-full.svg?react';
import WysiwygLinkOffIcon from '../../assets/images/icons/link-slash-light-full.svg?react';
import WysiwygEditIcon from '../../assets/images/icons/pen-light-full.svg?react';
import WysiwygTableIcon from '../../assets/images/icons/table-light-full.svg?react';
import WysiwygPlaceholderUserIcon from '../../assets/images/icons/user-light-full.svg?react';
import WysiwygPlaceholderCompanyIcon from '../../assets/images/icons/building-light-full.svg?react';
import WysiwygPlaceholderHomeIcon from '../../assets/images/icons/house-light-full.svg?react';
import WysiwygPlaceholderTrackingIcon from '../../assets/images/icons/bullseye-pointer-light-full.svg?react';

export {createIconComponent};

export const icons = {
    organization: createIconComponent(OrganizationIcon),
    user: createIconComponent(UserIcon),
    tag: createIconComponent(TagsIcon),
    tagSingle: createIconComponent(TagSingleIcon),
    member: createIconComponent(MembersIcon),
    group: createIconComponent(TeamsIcon),
    stats: createIconComponent(StatsIcon),
    globalStats: createIconComponent(GlobalStatsIcon),
    order: createIconComponent(OrderIcon),
    shipment: createIconComponent(EnvelopeIcon),
    kompany: createIconComponent(KompanyIcon),
    profile: createIconComponent(ProfileIcon),
    medium: createIconComponent(MediumIcon),
    mediumProd: createIconComponent(MediumProdIcon),
    import: createIconComponent(TableIcon),
    leadCapture: createIconComponent(LeadCaptureIcon),
    lead: createIconComponent(LeadIcon),
    asset: createIconComponent(AssetIcon),
    signature: createIconComponent(EnvelopeIcon),
    leadForm: createIconComponent(LeadFormIcon),
    subscriptions: createIconComponent(SubscriptionsIcon),
    production: createIconComponent(ProductionIcon),
    sso: createIconComponent(SsoIcon),
    users: createIconComponent(UsersIcon),
    accountTrigger: createIconComponent(AccountTriggerIcon),
    account: createIconComponent(AccountIcon),
    inviteMember: createIconComponent(InviteMemberIcon),
    orgSettings: createIconComponent(OrgSettingsIcon),
    buy: createIconComponent(BuyIcon),
    logout: createIconComponent(LogoutIcon),
    settings: createIconComponent(SettingsIcon),
    help: createIconComponent(HelpIcon),
    collapse: createIconComponent(ChevronLeftIcon),
    statViews: createIconComponent(StatViewsIcon),
    statProfileScan: createIconComponent(StatProfileScanIcon),
    report: createIconComponent(ReportIcon),
    dropzone: createIconComponent(DropzoneIcon),
    edit: createIconComponent(EditIcon),
    view: createIconComponent(ViewIcon),
    add: createIconComponent(AddIcon),
    plus: createIconComponent(PlusIcon),
    minus: createIconComponent(MinusIcon),
    sheet: createIconComponent(TableIcon),
    campaign: createIconComponent(CampaignIcon),
    model: createIconComponent(ModelIcon),
    delete: createIconComponent(DeleteIcon),
    editProfile: createIconComponent(EditProfileIcon),
    share: createIconComponent(ShareIcon),
    profileSettings: createIconComponent(ProfileSettingsIcon),
    permissions: createIconComponent(PermissionsIcon),
    operations: createIconComponent(SettingsIcon),
    download: createIconComponent(DownloadIcon),
    manualEntry: createIconComponent(ManualEntryIcon),
    cameraScan: createIconComponent(CameraScanIcon),
    addLead: createIconComponent(InviteMemberIcon),
    features: createIconComponent(FeaturesIcon),
    plan: createIconComponent(PlanIcon),
    members: createIconComponent(MembersIcon),
    teams: createIconComponent(TeamsIcon),
    security: createIconComponent(SecurityIcon),
    integrations: createIconComponent(IntegrationsIcon),
    vcard: createIconComponent(VcardIcon),
    exchange: createIconComponent(ExchangeIcon),
    shareProfile: createIconComponent(ShareProfileIcon),
    menuBars: createIconComponent(MenuBarsIcon),
    close: createIconComponent(CloseIcon),
    none: createIconComponent(NoneIcon),
    phone: createIconComponent(PhoneIcon),
    video: createIconComponent(VideoIcon),
    file: createIconComponent(FileIcon),
    calendar: createIconComponent(CalendarIcon),
    linkExternal: createIconComponent(LinkExternalIcon),
    openExternal: createIconComponent(OpenExternalIcon),
    copy: createIconComponent(CopyIcon),
    locked: createIconComponent(LockedIcon),
    notAllowed: createIconComponent(NotAllowedIcon),
    merge: createIconComponent(MergeIcon),
    impersonate: createIconComponent(ImpersonateIcon),
    toggleOnLarge: createIconComponent(ToggleOnLargeIcon),
    toggleOffLarge: createIconComponent(ToggleOffLargeIcon),
    orderTransition: createIconComponent(OrderTransitionIcon),
    moveToOrg: createIconComponent(MoveToOrgIcon),
    wooCommerce: createIconComponent(WooCommerceIcon),
    save: createIconComponent(SaveIcon),
    image: createIconComponent(ImageIcon),
    viewOff: createIconComponent(ViewOffIcon),
    allOrganizations: createIconComponent(AllOrganizationsIcon),
    fingerprint: createIconComponent(FingerprintIcon),
    viewList: createIconComponent(ViewListIcon),
    viewGrid: createIconComponent(ViewGridIcon),
    check: createIconComponent(CheckIcon),
    deleteForever: createIconComponent(DeleteForeverIcon),
    refresh: createIconComponent(RefreshIcon),
    back: createIconComponent(BackIcon),
    send: createIconComponent(SendIcon),
    chevronDown: createIconComponent(ChevronDownIcon),
    next: createIconComponent(NextIcon),
    lock: createIconComponent(LockIcon),
    qrCode: createIconComponent(QrCodeIcon),
    error: createIconComponent(ErrorIcon),
    info: createIconComponent(InfoIcon),
    checkCircle: createIconComponent(CheckCircleIcon),
    warning: createIconComponent(WarningIcon),
    question: createIconComponent(QuestionIcon),
    alert: createIconComponent(AlertIcon),
    sort: createIconComponent(SortIcon),
    filter: createIconComponent(FilterIcon),
    clearFilters: createIconComponent(ClearFiltersIcon),
    translate: createIconComponent(TranslateIcon),
    public: createIconComponent(PublicIcon),
    attachment: createIconComponent(AttachmentIcon),
    email: createIconComponent(EmailIcon),
    customize: createIconComponent(CustomizeIcon),
    dragHandle: createIconComponent(DragHandleIcon),
    upload: createIconComponent(UploadIcon),
    checkboxEmpty: createIconComponent(CheckboxEmptyIcon),
    adminShield: createIconComponent(AdminShieldIcon),
    transfer: createIconComponent(TransferIcon),
    moreVert: createIconComponent(MoreVertIcon),
    moreHoriz: createIconComponent(MoreHorizIcon),
    gears: createIconComponent(GearsIcon),
    linkOff: createIconComponent(LinkOffIcon),
    nfc: createIconComponent(NfcIcon),
    location: createIconComponent(LocationIcon),
    creditCard: createIconComponent(CreditCardIcon),
    contactCard: createIconComponent(ContactCardIcon),
    flag: createIconComponent(FlagIcon),
    search: createIconComponent(SearchIcon),
    home: createIconComponent(HomeIcon),
    recycle: createIconComponent(RecycleIcon),
    article: createIconComponent(ArticleIcon),
    airplaneOffline: createIconComponent(AirplaneOfflineIcon),
    magic: createIconComponent(MagicIcon),
    tracking: createIconComponent(TrackingIcon),
    filePdf: createIconComponent(FilePdfIcon),
    fileAudio: createIconComponent(FileAudioIcon),
    fileVideo: createIconComponent(FileVideoIcon),
    paste: createIconComponent(PasteIcon),
    addToHomeScreen: createIconComponent(AddToHomeScreenIcon),
    lockOpen: createIconComponent(LockOpenIcon),
    gift: createIconComponent(GiftIcon),
    mobile: createIconComponent(MobileIcon),
    shieldCheck: createIconComponent(ShieldCheckIcon),
    crown: createIconComponent(CrownIcon),
    // WYSIWYG editor (Tiptap signature toolbar)
    wysiwygBold: createIconComponent(WysiwygBoldIcon),
    wysiwygItalic: createIconComponent(WysiwygItalicIcon),
    wysiwygUnderline: createIconComponent(WysiwygUnderlineIcon),
    wysiwygStrikethrough: createIconComponent(WysiwygStrikethroughIcon),
    wysiwygClearFormat: createIconComponent(WysiwygClearFormatIcon),
    wysiwygTextColor: createIconComponent(WysiwygTextColorIcon),
    wysiwygTextHighlight: createIconComponent(WysiwygTextHighlightIcon),
    wysiwygTextIncrease: createIconComponent(WysiwygTextIncreaseIcon),
    wysiwygTextDecrease: createIconComponent(WysiwygTextDecreaseIcon),
    wysiwygAlignLeft: createIconComponent(WysiwygAlignLeftIcon),
    wysiwygAlignCenter: createIconComponent(WysiwygAlignCenterIcon),
    wysiwygAlignRight: createIconComponent(WysiwygAlignRightIcon),
    wysiwygAlignJustify: createIconComponent(WysiwygAlignJustifyIcon),
    wysiwygListBulleted: createIconComponent(WysiwygListBulletedIcon),
    wysiwygListNumbered: createIconComponent(WysiwygListNumberedIcon),
    wysiwygQuote: createIconComponent(WysiwygQuoteIcon),
    wysiwygLink: createIconComponent(WysiwygLinkIcon),
    wysiwygUndo: createIconComponent(WysiwygUndoIcon),
    wysiwygRedo: createIconComponent(WysiwygRedoIcon),
    wysiwygSave: createIconComponent(WysiwygSaveIcon),
    wysiwygLinkOff: createIconComponent(WysiwygLinkOffIcon),
    wysiwygEdit: createIconComponent(WysiwygEditIcon),
    wysiwygTable: createIconComponent(WysiwygTableIcon),
    wysiwygPlaceholderUser: createIconComponent(WysiwygPlaceholderUserIcon),
    wysiwygPlaceholderCompany: createIconComponent(
        WysiwygPlaceholderCompanyIcon,
    ),
    wysiwygPlaceholderHome: createIconComponent(WysiwygPlaceholderHomeIcon),
    wysiwygPlaceholderTracking: createIconComponent(
        WysiwygPlaceholderTrackingIcon,
    ),
};
